import type { InjectionKey } from 'vue';

import type { ValueAddedServiceDto } from '~/apiClient';

export const INJECTION_KEYS = {
    SALES_CONTACT: Symbol('SALES_CONTACT') as InjectionKey<ComputedRef<SalesContact | undefined>>,
    VALUE_ADDED_SERVICES: Symbol('VALUE_ADDED_SERVICES') as InjectionKey<Ref<ValueAddedServiceDto[] | undefined>>,
} as const;
